import { useEffect } from 'react';

export function useApplicationTitle() {
  useEffect(() => {
    if (process.env.REACT_APP_TITLE) {
      document.title = window._env_.REACT_APP_TITLE;
    }
  }, []);
}
